import { PolarAngleAxis, RadialBar, RadialBarChart } from 'recharts';
import type { HealthScore } from '../../types/org.types';

function colorFor(score: number): string {
  if (score >= 70) return '#3FA96B'; // grow
  if (score >= 50) return '#C7851A'; // sunrise
  return '#D64545'; // sunset
}

export function HealthGauge({ score }: { score: HealthScore }) {
  const color = colorFor(score.total);
  const data = [{ name: 'score', value: score.total, fill: color }];
  return (
    <div className="relative">
      <RadialBarChart
        width={240}
        height={240}
        cx={120}
        cy={120}
        innerRadius={92}
        outerRadius={112}
        startAngle={210}
        endAngle={-30}
        data={data}
      >
        <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
        <RadialBar background={{ fill: '#E0DED7' }} dataKey="value" cornerRadius={0} />
      </RadialBarChart>
      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
        <div className="text-5xl font-bold text-crux-light tabular-nums">{score.total}</div>
        <div className="text-xs uppercase tracking-widest text-neutral-500 mt-1">/ 100</div>
        <div className="text-sm font-medium mt-2" style={{ color }}>
          {score.label}
        </div>
      </div>
    </div>
  );
}
